import React from 'react'
import {Box, Skeleton, SkeletonText, SimpleGrid, VStack, Container} from '@chakra-ui/react'

const EspSkeleton = () => {
    return (
        <Box w="100%" bg="white">
            {/* Hero Banner */}
            <Skeleton height="600px" w="100%" borderRadius="none" />

            {/* Section: Full Image x 4 */}
            <Container maxW="6xl" py={10}>
                <VStack spacing={8}>
                    <Skeleton height="40px" width="250px" />
                    <SimpleGrid columns={{base: 2, md: 4}} spacing={6} w="100%">
                        {[...Array(4)].map((_, i) => (
                            <Skeleton key={i} height="300px" borderRadius="xl" />
                        ))}
                    </SimpleGrid>
                </VStack>
            </Container>

            {/* Section: Image Row of two */}
            <Container maxW="6xl" py={10}>
                <SimpleGrid columns={{base: 1, md: 2}} spacing={10}>
                    {[...Array(2)].map((_, i) => (
                        <VStack key={i} align="start" spacing={4}>
                            <Skeleton height="400px" w="100%" borderRadius="xl" />
                            <SkeletonText mt="4" noOfLines={1} spacing="4" width="40%" />
                        </VStack>
                    ))}
                </SimpleGrid>
            </Container>

            {/* Section: Hero Banner */}
            <Container maxW="6xl" py={10}>
                <VStack align="start" spacing={4}>
                    <Skeleton height="500px" w="100%" borderRadius="xl" />
                    <SkeletonText mt="4" noOfLines={1} spacing="4" width="30%" />
                </VStack>
            </Container>

            {/* Section: Recommendations */}
            <Container maxW="7xl" py={10}>
                <VStack align="start" spacing={6}>
                    <Skeleton height="30px" width="200px" />
                    <SimpleGrid columns={{base: 2, md: 4, lg: 5}} spacing={6} w="100%">
                        {[...Array(5)].map((_, i) => (
                            <VStack key={i} align="center">
                                <Skeleton height="250px" w="100%" borderRadius="xl" />
                                <SkeletonText mt="3" noOfLines={2} spacing="3" w="80%" />
                            </VStack>
                        ))}
                    </SimpleGrid>
                </VStack>
            </Container>

            {/* Section: Shop The Look */}
            <Container maxW="6xl" py={10}>
                <VStack align="start" spacing={6}>
                    <Skeleton height="30px" width="200px" />
                    <SimpleGrid columns={{base: 1, md: 3}} spacing={6}>
                        {[...Array(3)].map((_, i) => (
                            <Skeleton key={i} height="400px" borderRadius="xl" />
                        ))}
                    </SimpleGrid>
                </VStack>
            </Container>

            {/* Section: Our Story */}
            <Container maxW="6xl" py={10}>
                <SimpleGrid columns={{base: 1, md: 2}} spacing={10}>
                    <Skeleton height="400px" borderRadius="xl" />
                    <VStack spacing={4} align="start">
                        <Skeleton height="30px" width="200px" />
                        <SkeletonText mt="4" noOfLines={5} spacing="4" />
                    </VStack>
                </SimpleGrid>
            </Container>
        </Box>
    )
}

export default EspSkeleton
